export default "<span [ngClass]=\"class\">{{ text | translate }}</span>";